import { AsYouType } from 'libphonenumber-js';

function digitsOf(value) {
    return (value || '').replace(/\D/g, '');
}

// A copied number can carry invisible direction / zero-width marks and Unicode dashes.
function normalizeCopiedPhone(value) {
    return value
        .replace(/[\u061C\u200B-\u200F\u202A-\u202E\u2060-\u2069\uFEFF]/g, '')
        .replace(/[\u2010-\u2015\u2212]/g, '-');
}

// Same library and approach as the rest of manage (intlphone.js,
// PhoneRecipients, KeywordPhoneRecipients): libphonenumber's AsYouType.
//
// `previous` is what makes deletion work. AsYouType re-adds punctuation it owns,
// so backspacing over the ")" in "(425) " would be undone on the next keystroke
// and the caret would appear stuck. When the user shortened the value without
// removing a digit, they deleted a separator - pass the raw value through and
// let the next typed digit re-format.
export function formatPhoneAsTyped(value, previous = '', country = 'US') {
    if (!value) {
        return '';
    }

    if (previous && value.length < previous.length && digitsOf(value) === digitsOf(previous)) {
        return value;
    }

    // A number copied from Contacts ("+1 214-555-0123") or a dialer ("12145550123")
    // carries the US country code; a complete one formats like the same paste
    // without it. Only a complete value is stripped, so a "+1" typed by hand does not
    // vanish mid-keystroke, and digits after an extension marker ("x5", "*5", "/5")
    // are never folded into the number.
    const digits = digitsOf(value);
    if (country === 'US' && digits.length === 11 && digits.startsWith('1')
        && /^\s*\+?[\d\s().-]+$/.test(normalizeCopiedPhone(value))) {
        return new AsYouType(country).input(digits.slice(1));
    }

    // Any other value with a leading "+" is an explicit country code; AsYouType
    // reads it from the input itself, so passing a default country would fight it.
    const formatter = value.trim().startsWith('+') ? new AsYouType() : new AsYouType(country);

    return formatter.input(value);
}

export default formatPhoneAsTyped;
